import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { applyDistance, applyPath, getProximitySpeedFactor, spin } from "./Utils";
import { getDistance, getRangeMax, getRangeValue } from "../../Utils/NumberUtils";
export var BaseMover = /*#__PURE__*/function () {
  function BaseMover() {
    _classCallCheck(this, BaseMover);
  }
  _createClass(BaseMover, [{
    key: "init",
    value: function init(particle) {
      var _a;
      var container = particle.container,
        options = particle.options,
        spinOptions = options.move.spin;
      if (spinOptions.enable) {
        var spinPos = (_a = spinOptions.position) !== null && _a !== void 0 ? _a : {
          x: 50,
          y: 50
        };
        var spinCenter = {
          x: spinPos.x / 100 * container.canvas.size.width,
          y: spinPos.y / 100 * container.canvas.size.height
        };
        var pos = particle.getPosition();
        var distance = getDistance(pos, spinCenter);
        var spinAcceleration = getRangeValue(spinOptions.acceleration);
        particle.retina.spinAcceleration = spinAcceleration * container.retina.pixelRatio;
        particle.spin = {
          center: spinCenter,
          direction: particle.velocity.x >= 0 ? "clockwise" : "counter-clockwise",
          angle: particle.velocity.angle,
          radius: distance,
          acceleration: particle.retina.spinAcceleration
        };
      }
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(particle) {
      return !particle.destroyed && particle.options.move.enable;
    }
  }, {
    key: "move",
    value: function move(particle, delta) {
      var _a, _b, _c;
      var _d, _e;
      var particleOptions = particle.options,
        moveOptions = particleOptions.move;
      if (!moveOptions.enable) {
        return;
      }
      var container = particle.container,
        slowFactor = getProximitySpeedFactor(particle),
        baseSpeed = ((_a = (_d = particle.retina).moveSpeed) !== null && _a !== void 0 ? _a : _d.moveSpeed = getRangeValue(moveOptions.speed) * container.retina.pixelRatio) * container.retina.reduceFactor,
        moveDrift = (_b = (_e = particle.retina).moveDrift) !== null && _b !== void 0 ? _b : _e.moveDrift = getRangeValue(particle.options.move.drift) * container.retina.pixelRatio,
        maxSize = getRangeMax(particleOptions.size.value) * container.retina.pixelRatio,
        sizeFactor = moveOptions.size ? particle.getRadius() / maxSize : 1,
        speedFactor = sizeFactor * slowFactor * (delta.factor || 1),
        diffFactor = 2,
        moveSpeed = baseSpeed * speedFactor / diffFactor;
      applyPath(particle, delta);
      var gravityOptions = particle.gravity,
        gravityFactor = gravityOptions.enable && gravityOptions.inverse ? -1 : 1;
      if (gravityOptions.enable && moveSpeed) {
        particle.velocity.y += gravityFactor * (gravityOptions.acceleration * delta.factor) / (60 * moveSpeed);
      }
      if (moveDrift && moveSpeed) {
        particle.velocity.x += moveDrift * delta.factor / (60 * moveSpeed);
      }
      var decay = particle.moveDecay;
      if (decay != 1) {
        particle.velocity.multTo(decay);
      }
      var velocity = particle.velocity.mult(moveSpeed),
        maxSpeed = (_c = particle.retina.maxSpeed) !== null && _c !== void 0 ? _c : container.retina.maxSpeed;
      if (gravityOptions.enable && maxSpeed > 0 && (!gravityOptions.inverse && velocity.y >= 0 && velocity.y >= maxSpeed || gravityOptions.inverse && velocity.y <= 0 && velocity.y <= -maxSpeed)) {
        velocity.y = gravityFactor * maxSpeed;
        if (moveSpeed) {
          particle.velocity.y = velocity.y / moveSpeed;
        }
      }
      var zIndexOptions = particle.options.zIndex,
        zVelocityFactor = Math.pow(1 - particle.zIndexFactor, zIndexOptions.velocityRate);
      if (moveOptions.spin.enable) {
        spin(particle, moveSpeed);
      } else {
        if (zVelocityFactor != 1) {
          velocity.multTo(zVelocityFactor);
        }
        particle.position.addTo(velocity);
        if (moveOptions.vibrate) {
          particle.position.x += Math.sin(particle.position.x * Math.cos(particle.position.y));
          particle.position.y += Math.cos(particle.position.y * Math.sin(particle.position.x));
        }
      }
      applyDistance(particle);
    }
  }]);
  return BaseMover;
}();